module.exports = __webpack_public_path__ + "img/sr-logo-50.8b0e5fc3.png";